import config from '../../config';
import { getAuthHeaders, handleResponse } from './common';

const PORTAL_MANAGEABLE_STATUSES = new Set(['Active', 'Trialing', 'PastDue', 'Incomplete']);

function readApiErrorMessage(body, fallback) {
    if (!body) return fallback;
    if (typeof body === 'string' && body.trim()) return body;
    if (typeof body !== 'object') return fallback;

    const candidates = [body.message, body.detail, body.error, body.title];
    for (const candidate of candidates) {
        if (typeof candidate === 'string' && candidate.trim()) return candidate;
    }
    return fallback;
}

export function subscriptionNeedsCheckout(subscription) {
    if (!subscription) return false;
    if (subscription.requiresCheckout === true) return true;
    if (subscription.isActive === false) {
        return !PORTAL_MANAGEABLE_STATUSES.has(subscription.status);
    }
    return false;
}

export function canManageSubscriptionInPortal(subscription) {
    if (!subscription || subscriptionNeedsCheckout(subscription)) return false;
    return PORTAL_MANAGEABLE_STATUSES.has(subscription.status);
}

const billingApi = {
    getSubscription: async () => {
        const res = await fetch(`${config.api.url}/billing/subscription`, {
            headers: getAuthHeaders()
        });
        return handleResponse(res);
    },

    createCheckoutSession: async (tier, successUrl, cancelUrl) => {
        const res = await fetch(`${config.api.url}/billing/checkout-session`, {
            method: 'POST',
            headers: getAuthHeaders(),
            body: JSON.stringify({ tier, successUrl, cancelUrl })
        });
        return handleResponse(res);
    },

    createPortalSession: async (returnUrl) => {
        const res = await fetch(`${config.api.url}/billing/portal-session`, {
            method: 'POST',
            headers: getAuthHeaders(),
            body: JSON.stringify({ returnUrl })
        });

        if (res.status === 400) {
            const errorText = await res.text();
            let parsedBody = null;
            if (errorText) {
                try {
                    parsedBody = JSON.parse(errorText);
                } catch {
                    parsedBody = errorText;
                }
            }
            const error = new Error(readApiErrorMessage(
                parsedBody,
                'Failed to open billing portal. Please try again.'
            ));
            error.status = 400;
            error.body = parsedBody;
            throw error;
        }

        return handleResponse(res);
    }
};

export default billingApi;
